const pageGlobals = window.pageGlobals;

export default window.pageGlobals;
